import { getGlobal } from "../lib/get-global";
import { gerReferrer, getSourceUrl } from "../lib/utils";
import { Beacon } from "./beacon";

export function createPageViewPlugin(beacon: Beacon) {
  let autoPageTrackInitialized = false;
  function pageView() {
    // only want to send in a browser environmnet
    const globalThis = getGlobal();
    if (
      typeof globalThis === "undefined" ||
      typeof document === "undefined" ||
      typeof location === "undefined"
    ) {
      return;
    }

    const sourceUrl = getSourceUrl();
    const referrer = gerReferrer();

    return beacon.sendBeacon({
      type: "PAGE_VIEW",
      data: { sourceUrl, referrer },
    });
  }

  function enableAutoPageViews(props?: { trackReplaceState?: boolean }) {
    const { trackReplaceState = false } = props || {};

    // only want to send in a browser environmnet
    const globalThis = getGlobal();
    if (
      typeof globalThis === "undefined" ||
      typeof history === "undefined" ||
      autoPageTrackInitialized === true
    ) {
      return () => {};
    }

    // prevent multiple calls to enableAutoPageViews
    autoPageTrackInitialized = true;

    // initial page view
    pageView();

    const track = () => pageView();
    const pushState = history.pushState;
    const replaceState = history.replaceState;

    // monkey patch history
    if (pushState && replaceState) {
      history.pushState = function (data, unused, url) {
        pushState.call(this, data, unused, url);
        track();
      };
      history.replaceState = function (data, unused, url) {
        replaceState.call(this, data, unused, url);

        if (trackReplaceState) {
          track();
        }
      };
      addEventListener("popstate", track);
    }

    return function () {
      if (pushState) {
        history.pushState = pushState;
        history.replaceState = replaceState;
        removeEventListener("popstate", track);
      }
    };
  }

  return {
    pageView,
    enableAutoPageViews,
  };
}
